/* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
import Head from 'next/head';
import React, { useContext, useEffect, } from 'react';
import { MessagesContext } from '@/pages/_app';
import Toasts from '@/components/toasts';
import { messages, } from '@/helpers/index';

export default function LayoutComponent({ children }) {
  const { stateMessages, dispatchMessages } = useContext(MessagesContext);

  useEffect(() => { }, []);

  return (
    <>
      <Head />
      <div className="land">{children}</div>
      <Toasts items={stateMessages.messages} clear={messages.clear} />
    </>
  );
}
